module.exports = __webpack_public_path__ + "img/1.b490c77b.svg";